export const SITE_ORIGIN = 'https://shops.mt';
export const SITE_NAME = 'Shops.mt';

export const DEFAULT_DESCRIPTION =
  'Search and compare products from Maltese online stores. Find local deals, check stock, and shop from retailers you trust — all in one place.';

export function absoluteUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized}`;
}

export const DEFAULT_OG_IMAGE = absoluteUrl('/og-image.png');
export const DEFAULT_OG_IMAGE_WIDTH = 1200;
export const DEFAULT_OG_IMAGE_HEIGHT = 630;

export const DEFAULT_OG_SQUARE_IMAGE = absoluteUrl('/og-square.png');
export const DEFAULT_OG_SQUARE_IMAGE_SIZE = 1200;

export function categoryPageTitle(categoryName) {
  return `${categoryName} in Malta | ${SITE_NAME}`;
}

export function categoryMetaDescription(categoryName) {
  return `Compare ${categoryName.toLowerCase()} from Maltese online stores. See prices, check stock, and shop from local retailers — all in one place.`;
}

export function categoryIntro(categoryName) {
  return `Browse and compare ${categoryName.toLowerCase()} from online shops in Malta. Prices and stock are aggregated from local retailers.`;
}

export function subcategoryPageTitle(subcategoryName) {
  return `${subcategoryName} in Malta | Compare prices | ${SITE_NAME}`;
}

export function subcategoryMetaDescription(subcategoryName) {
  return `Compare ${subcategoryName.toLowerCase()} prices from Maltese online stores. Find deals and check availability across local retailers.`;
}

export function subcategoryIntro(subcategoryName) {
  return `Compare ${subcategoryName.toLowerCase()} prices from Maltese online stores. Find deals and check availability across local retailers.`;
}

export function priceCollectionPageTitle(collectionName) {
  return `${collectionName} in Malta | Compare prices | ${SITE_NAME}`;
}

export function priceCollectionMetaDescription(collectionName) {
  return `Browse ${collectionName.toLowerCase()} from Maltese online stores. Compare prices and check stock across local retailers.`;
}

export function priceCollectionIntro(collectionName) {
  return `Discover ${collectionName.toLowerCase()} from online shops in Malta. Prices and stock are aggregated from local retailers.`;
}

/**
 * @param {Array<{ name: string, url: string }>} items
 */
export function breadcrumbJsonLd(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.url),
    })),
  };
}

export const HOME_WEBSITE_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  url: SITE_ORIGIN,
  description: DEFAULT_DESCRIPTION,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_ORIGIN}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};
